import localConfig from './local';

const defaultConfig = {
  appDomain: 'bikesbooking.com',
  appProtocol: 'http',
  apiRoot: '/api/',
  defaultLang: 'en',
  stripeApiKey: '',
  stripeLogoUrl: 'https://s3.amazonaws.com/stripe-uploads/acct_19OxMUG5a2t1rzdomerchant-icon-1483001627145-LOGO-quad.jpg',
  minimalBookingOffset: 24, // Hours
  enableTimeline: 'true',
  enableSiteIntegrations: 'true',

  GOOGLE_MAP_API_KEY: 'AIzaSyDm5rc-Cf3NuskrY8OtNLI8l5-MpmUGkRU',
  FACEBOOK_APP_ID: '',
  TRAVEL_PAYOUTS_HOSTNAME: '',

  server: {
    host: '127.0.0.1',
    port: 5000,
    apiHost: '127.0.0.1',
    apiPort: 8000,
    apiProtocol: 'http',
    resourceDir: ''
  }
};

function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item) && item !== null);
}

function mergeDeep(target, source) {
  const output = Object.assign({}, target);

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] });
        } else {
          output[key] = mergeDeep(target[key], source[key]);
        }
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }

  return output;
}

const config = mergeDeep(defaultConfig, localConfig);
export default config;



// WEBPACK FOOTER //
// ./src/config/index.js